<script setup lang="ts">
import { ref } from 'vue'
import { useKeysStore } from '@/stores/keys'

import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    keyId: number
    modelValue?: boolean
    disabled?: boolean
    blockedByFilter?: boolean
  }>(),
  {
    modelValue: true,
    disabled: false,
    blockedByFilter: false,
  },
)

const keys = useKeysStore()
const saving = ref(false)

// Когда ключ исключён глобальным фильтром подписки, switch не должен ему противоречить:
// показываем выключенным и блокируем.
const effectiveChecked = computed(() => props.blockedByFilter ? false : props.modelValue !== false)
const isDisabled = computed(() => props.disabled || saving.value || props.blockedByFilter)
const title = computed(() =>
  props.blockedByFilter
    ? 'Ключ исключён фильтром подписки — отключите фильтр, чтобы управлять им'
    : 'Включить ключ в ссылку подписки',
)

async function onChange(event: Event) {
  const input = event.target as HTMLInputElement
  if (props.blockedByFilter) {
    input.checked = false
    return
  }
  const checked = input.checked
  saving.value = true
  try {
    const res = await keys.setIncludeInSublink(props.keyId, checked)
    if (!res.success) {
      input.checked = !checked
    }
  } catch {
    input.checked = !checked
  } finally {
    saving.value = false
  }
}
</script>

<template>
  <label
    class="relative inline-flex h-5 w-9 shrink-0 self-center align-middle"
    :class="{ 'opacity-50': blockedByFilter }"
    :title="title"
  >
    <input
      type="checkbox"
      class="custom_switch peer absolute inset-0 z-10 m-0 cursor-pointer opacity-0 disabled:cursor-not-allowed"
      :checked="effectiveChecked"
      :disabled="isDisabled"
      @change="onChange"
    />
    <span
      class="block h-full w-full rounded-full bg-[#ebedf2] before:absolute before:top-1/2 before:left-[2px] before:h-[14px] before:w-[14px] before:-translate-y-1/2 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-[20px] dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
    />
  </label>
</template>
